import { useState } from 'react'

import axios from 'axios'

export interface MetadataLink {
  url: string
  title: string
  description: string
  mediaType: string
  contentType: string
  images: string[]
  videos: any[]
  favicons: string[]
  charset: string
}

const useFetchMetadata = () => {
  const [loading, setLoading] = useState(false) // Add loading state

  const fetchMetadata = async (url: string) => {
    try {
      setLoading(true)
      const meta = await axios.get(`/api/scrape?url=${encodeURIComponent(url)}`).then((res) => res.data)
      setLoading(false)
      return meta
    } catch (err) {
      setLoading(false)
      console.log('🚀 ~ handleScrape ~ err:', err)
    }
  }

  return {
    loading,
    fetchMetadata,
  }
}
export default useFetchMetadata
